import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

export const ChangeAgentPasswordModal = ({
  open,
  onClose,
  agent,
  onResetPassword,
  isResetting = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h3" sx={{ py: 2 }}>
        Restablecer contraseña
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {agent?.display_name
            ? `Se generara una contraseña temporal para ${agent.display_name}.`
            : 'Se generara una contraseña temporal para el agente.'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          El agente deberá cambiarla en el proximo inicio de sesión.
        </Typography>

      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined">Cerrar</Button>
        <Box sx={{ flex: 1 }} />
        <Button
          onClick={() => onResetPassword && onResetPassword(agent)}
          variant="contained"
          disabled={isResetting}
        >
          {isResetting ? 'Restableciendo...' : 'Restablecer contraseña'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ChangeAgentPasswordModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  agent: PropTypes.object,
  onResetPassword: PropTypes.func,
  isResetting: PropTypes.bool,
};
